import {GRANITE_8, SPRING_8} from '@gaia/colors';
import GaiaIcon from '@gaia/icons/GaiaIcon';
import {ampli} from '@gaia/utils/gaia/trackAnalytics';
import {getSidebarWidth} from '@map/sidebars';
import {Button, IconButton, Snackbar, SnackbarProps} from '@mui/material';
import {useCallback} from 'react';

interface UndoSnackbarProps extends SnackbarProps {
    undo: UndoState | undefined;
    setUndo: SetState<UndoState | undefined>;
    interactionType: InteractionState['type'];
    mapControlsOffset: number;
}

const SIDEBAR_WIDTH = getSidebarWidth();

export default function UndoSnackbar({
    undo,
    setUndo,
    interactionType,
    mapControlsOffset,
}: UndoSnackbarProps) {
    const handleClose = useCallback(() => setUndo(undefined), [setUndo]);
    return (
        <Snackbar
            open={interactionType === 'normal' && Boolean(undo)}
            sx={{bottom: {sm: 0}, left: {xs: mapControlsOffset}}}
            ContentProps={{
                sx: {
                    width: `${SIDEBAR_WIDTH}px`,
                    boxSizing: 'border-box',
                },
            }}
            onClose={handleClose}
            autoHideDuration={15000}
            anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
            message={undo?.message}
            action={
                <>
                    <Button
                        style={{color: SPRING_8}}
                        onClick={() => {
                            if (undo) undo.handler();
                            setUndo(undefined);
                            ampli.undoAction({
                                category: 'map2',
                                message: undo?.message,
                            });
                        }}
                    >
                        Undo
                    </Button>
                    <IconButton
                        aria-label='Close'
                        style={{
                            backgroundColor: 'transparent',
                            color: GRANITE_8,
                        }}
                        onClick={handleClose}
                        size='large'
                    >
                        <GaiaIcon name='cancel' style={{height: 24, width: 24}} />
                    </IconButton>
                </>
            }
        />
    );
}
